import React from 'react';
import ReactDOM from 'react-dom/client';
import { LogtoProvider, UserScope, type LogtoConfig } from '@logto/react';
import { App } from './App';
import { config } from './config';
import './style.css';

const logtoConfig: LogtoConfig = {
  endpoint: config.logtoEndpoint,
  appId: config.logtoAppId,
  // The token's `aud` must be the DeskTouch API or every call is refused.
  resources: [config.apiResource],
  // Email and profile claims let the panel show who is signed in even before
  // the API has mirrored the profile.
  scopes: [UserScope.Email, UserScope.Profile, UserScope.Identities],
};

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <LogtoProvider config={logtoConfig}>
      <App />
    </LogtoProvider>
  </React.StrictMode>,
);
